// reducers/homeReducer.js

export const initialHomeState = {
    shareSafaris: [],
    safariPackages: [],
    featurePark: [],
    rareAnimals: [],
    posts: [],
    loading: true, 
};

export const homeReducer = (state = initialHomeState, action) => {
    switch (action.type) {
        case "SET_LOADING":
            return {
                ...state,
                loading: typeof action.payload === "boolean" ? action.payload : state.loading,
            };
        case 'SET_HOME_SHARE_SAFARI':
            return {
                ...state,
                shareSafaris: Array.isArray(action.payload) ? action.payload : state.shareSafaris,
            };
        case 'SET_HOME_SAFARI_PACKAGES':
            return {
                ...state,
                safariPackages: Array.isArray(action.payload) ? action.payload : state.safariPackages,
            };
        case 'SET_HOME_FEATURE_PARK':
            return {
                ...state,
                featurePark: Array.isArray(action.payload) ? action.payload : state.featurePark,
            };
        case 'SET_HOME_RARE_ANIMALS':
            return {
                ...state,
                rareAnimals: Array.isArray(action.payload) ? action.payload : state.rareAnimals,
            };
        case 'SET_HOME_USERS_POSTS':
            return {
                ...state,
                posts: Array.isArray(action.payload) ? action.payload : state.posts,
            };

        default:
            return state;
    }
};
